const applyPromoComponent = () => import('@/views/applyPromo/applyPromo.vue')
const applyPromoCreate = () => import('@/views/applyPromo/createPromo.vue')

export default {
    path: 'applyPromo',
    meta: { label: 'Apply Promo' },
    component: {
        render(c) { return c('router-view') }
    },
    children: [
        {
            path: '',
            meta: {
                requiresAuth: true,
            },
            component:applyPromoComponent
        },
        {
            path: '/create',
            name:"promo-create",
            meta: {
                requiresAuth: true,
            },
            component:applyPromoCreate
        },
    ]
}